// ไฟล์: frontend/src/pages/admin/Subjects.js
import React, { useState, useEffect } from 'react';
import Header from '../../components/Header';
import Sidebar from '../../components/Sidebar';
import Footer from '../../components/Footer';
import api from '../../services/api';
import Swal from 'sweetalert2';

function AdminSubjects() {
  const [subjects, setSubjects] = useState([]);
  const [indicators, setIndicators] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  
  // State สำหรับ Modal วิชา
  const [showSubjectModal, setShowSubjectModal] = useState(false);
  const [subjectFormData, setSubjectFormData] = useState({
    id: '',
    subject_code: '',
    subject_name: '',
    description: ''
  });
  const [subjectFormMode, setSubjectFormMode] = useState('add'); // 'add' หรือ 'edit'
  
  // State สำหรับ Modal ตัวชี้วัด
  const [showIndicatorModal, setShowIndicatorModal] = useState(false);
  const [indicatorFormData, setIndicatorFormData] = useState({
    id: '',
    subject_id: '',
    indicator_code: '',
    indicator_name: '',
    full_score: 100,
    weight: 1,
    description: ''
  });
  const [indicatorFormMode, setIndicatorFormMode] = useState('add'); // 'add' หรือ 'edit'
  
  // State สำหรับการกรองตัวชี้วัดตามวิชา
  const [selectedSubjectId, setSelectedSubjectId] = useState('');
  
  useEffect(() => {
    fetchSubjects();
    fetchIndicators();
  }, []);
  
  // ดึงข้อมูลวิชา
  const fetchSubjects = async () => {
    try {
      setIsLoading(true);
      const response = await api.subject.getAllSubjects();
      setSubjects(response.data.data || []);
      
      // เลือกวิชาแรกเป็นค่าเริ่มต้น
      if (response.data.data && response.data.data.length > 0) {
        setSelectedSubjectId(response.data.data[0].id);
      }
    } catch (error) {
      console.error('Error fetching subjects:', error);
      Swal.fire({
        icon: 'error',
        title: 'เกิดข้อผิดพลาด',
        text: 'ไม่สามารถโหลดข้อมูลวิชาได้',
        confirmButtonColor: '#ff6b01'
      });
    } finally {
      setIsLoading(false);
    }
  };
  
  // ดึงข้อมูลตัวชี้วัด
  const fetchIndicators = async () => {
    try {
      setIsLoading(true);
      const response = await api.indicator.getAllIndicators();
      setIndicators(response.data.data || []);
    } catch (error) {
      console.error('Error fetching indicators:', error);
      Swal.fire({
        icon: 'error',
        title: 'เกิดข้อผิดพลาด',
        text: 'ไม่สามารถโหลดข้อมูลตัวชี้วัดได้',
        confirmButtonColor: '#ff6b01'
      });
    } finally {
      setIsLoading(false);
    }
  };
  
  // --- จัดการ Modal วิชา ---
  const handleShowAddSubjectModal = () => {
    setSubjectFormData({
      id: '',
      subject_code: '',
      subject_name: '',
      description: ''
    });
    setSubjectFormMode('add');
    setShowSubjectModal(true);
  };
  
  const handleShowEditSubjectModal = (subject) => {
    setSubjectFormData({
      id: subject.id,
      subject_code: subject.subject_code,
      subject_name: subject.subject_name,
      description: subject.description || ''
    });
    setSubjectFormMode('edit');
    setShowSubjectModal(true);
  };
  
  const handleCloseSubjectModal = () => {
    setShowSubjectModal(false);
  };
  
  const handleSubjectInputChange = (e) => {
    const { name, value } = e.target;
    setSubjectFormData({
      ...subjectFormData,
      [name]: value
    });
  };
  
  const handleSubjectSubmit = async (e) => {
    e.preventDefault();
    
    // ตรวจสอบข้อมูลที่จำเป็น
    if (!subjectFormData.subject_code || !subjectFormData.subject_name) {
      Swal.fire({
        icon: 'warning',
        title: 'กรุณากรอกข้อมูลให้ครบถ้วน',
        text: 'กรุณากรอกรหัสวิชาและชื่อวิชา',
        confirmButtonColor: '#ff6b01'
      });
      return;
    }
    
    try {
      setIsLoading(true);
      
      let response;
      if (subjectFormMode === 'add') {
        // เพิ่มวิชาใหม่
        response = await api.subject.createSubject(subjectFormData);
        Swal.fire({
          icon: 'success',
          title: 'สำเร็จ',
          text: 'เพิ่มวิชาเรียบร้อยแล้ว',
          confirmButtonColor: '#ff6b01'
        });
      } else {
        // แก้ไขข้อมูลวิชา
        response = await api.subject.updateSubject(subjectFormData.id, subjectFormData);
        Swal.fire({
          icon: 'success',
          title: 'สำเร็จ',
          text: 'แก้ไขข้อมูลวิชาเรียบร้อยแล้ว',
          confirmButtonColor: '#ff6b01'
        });
      }
      
      // ปิด Modal และโหลดข้อมูลใหม่
      setShowSubjectModal(false);
      fetchSubjects();
      fetchIndicators();
    } catch (error) {
      console.error('Error saving subject:', error);
      Swal.fire({
        icon: 'error',
        title: 'เกิดข้อผิดพลาด',
        text: 'ไม่สามารถบันทึกข้อมูลวิชาได้',
        confirmButtonColor: '#ff6b01'
      });
    } finally {
      setIsLoading(false);
    }
  };
  
  const handleDeleteSubject = (id) => {
    Swal.fire({
      title: 'ยืนยันการลบ',
      text: 'การลบวิชาจะทำให้ตัวชี้วัดและคะแนนที่เกี่ยวข้องถูกลบไปด้วย คุณแน่ใจหรือไม่?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#ff6b01',
      cancelButtonColor: '#d33',
      confirmButtonText: 'ใช่, ลบข้อมูล',
      cancelButtonText: 'ยกเลิก'
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          await api.subject.deleteSubject(id);
          Swal.fire({
            icon: 'success',
            title: 'ลบข้อมูลสำเร็จ',
            text: 'ลบข้อมูลวิชาเรียบร้อยแล้ว',
            confirmButtonColor: '#ff6b01'
          });
          fetchSubjects();
          fetchIndicators();
        } catch (error) {
          console.error('Error deleting subject:', error);
          Swal.fire({
            icon: 'error',
            title: 'เกิดข้อผิดพลาด',
            text: 'ไม่สามารถลบข้อมูลวิชาได้',
            confirmButtonColor: '#ff6b01'
          });
        }
      }
    });
  };
  
  // --- จัดการ Modal ตัวชี้วัด ---
  const handleShowAddIndicatorModal = () => {
    setIndicatorFormData({
      id: '',
      subject_id: selectedSubjectId,
      indicator_code: '',
      indicator_name: '',
      full_score: 100,
      weight: 1,
      description: ''
    });
    setIndicatorFormMode('add');
    setShowIndicatorModal(true);
  };
  
  const handleShowEditIndicatorModal = (indicator) => {
    setIndicatorFormData({
      id: indicator.id,
      subject_id: indicator.subject_id,
      indicator_code: indicator.indicator_code,
      indicator_name: indicator.indicator_name,
      full_score: indicator.full_score,
      weight: indicator.weight,
      description: indicator.description || ''
    });
    setIndicatorFormMode('edit');
    setShowIndicatorModal(true);
  };
  
  const handleCloseIndicatorModal = () => {
    setShowIndicatorModal(false);
  };
  
  const handleIndicatorInputChange = (e) => {
    const { name, value } = e.target;
    setIndicatorFormData({
      ...indicatorFormData,
      [name]: name === 'full_score' || name === 'weight' ? parseFloat(value) : value
    });
  };
  
  const handleIndicatorSubmit = async (e) => {
    e.preventDefault();
    
    // ตรวจสอบข้อมูลที่จำเป็น
    if (!indicatorFormData.subject_id || !indicatorFormData.indicator_code || !indicatorFormData.indicator_name) {
      Swal.fire({
        icon: 'warning',
        title: 'กรุณากรอกข้อมูลให้ครบถ้วน',
        text: 'กรุณากรอกรหัสวิชา รหัสตัวชี้วัด และชื่อตัวชี้วัด',
        confirmButtonColor: '#ff6b01'
      });
      return;
    }
    
    try {
      setIsLoading(true);
      
      let response;
      if (indicatorFormMode === 'add') {
        // เพิ่มตัวชี้วัดใหม่
        response = await api.indicator.createIndicator(indicatorFormData);
        Swal.fire({
          icon: 'success',
          title: 'สำเร็จ',
          text: 'เพิ่มตัวชี้วัดเรียบร้อยแล้ว',
          confirmButtonColor: '#ff6b01'
        });
      } else {
        // แก้ไขข้อมูลตัวชี้วัด
        response = await api.indicator.updateIndicator(indicatorFormData.id, indicatorFormData);
        Swal.fire({
          icon: 'success',
          title: 'สำเร็จ',
          text: 'แก้ไขข้อมูลตัวชี้วัดเรียบร้อยแล้ว',
          confirmButtonColor: '#ff6b01'
        });
      }
      
      // ปิด Modal และโหลดข้อมูลใหม่
      setShowIndicatorModal(false);
      fetchIndicators();
    } catch (error) {
      console.error('Error saving indicator:', error);
      Swal.fire({
        icon: 'error',
        title: 'เกิดข้อผิดพลาด',
        text: 'ไม่สามารถบันทึกข้อมูลตัวชี้วัดได้',
        confirmButtonColor: '#ff6b01'
      });
    } finally {
      setIsLoading(false);
    }
  };
  
  const handleDeleteIndicator = (id) => {
    Swal.fire({
      title: 'ยืนยันการลบ',
      text: 'การลบตัวชี้วัดจะทำให้คะแนนของนักเรียนตามตัวชี้วัดนี้ถูกลบไปด้วย คุณแน่ใจหรือไม่?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#ff6b01',
      cancelButtonColor: '#d33',
      confirmButtonText: 'ใช่, ลบข้อมูล',
      cancelButtonText: 'ยกเลิก'
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          await api.indicator.deleteIndicator(id);
          Swal.fire({
            icon: 'success',
            title: 'ลบข้อมูลสำเร็จ',
            text: 'ลบข้อมูลตัวชี้วัดเรียบร้อยแล้ว',
            confirmButtonColor: '#ff6b01'
          });
          fetchIndicators();
        } catch (error) {
          console.error('Error deleting indicator:', error);
          Swal.fire({
            icon: 'error',
            title: 'เกิดข้อผิดพลาด',
            text: 'ไม่สามารถลบข้อมูลตัวชี้วัดได้',
            confirmButtonColor: '#ff6b01'
          });
        }
      }
    });
  };
  
  // กรองตัวชี้วัดตามวิชาที่เลือก
  const filteredIndicators = selectedSubjectId
    ? indicators.filter(indicator => indicator.subject_id === parseInt(selectedSubjectId))
    : indicators;
  
  return (
    <div className="wrapper">
      <Header />
      <Sidebar />
      
      <div className="content-wrapper">
        <div className="content-header">
          <div className="container-fluid">
            <div className="row mb-2">
              <div className="col-sm-6">
                <h1 className="m-0">จัดการวิชาและตัวชี้วัด</h1>
              </div>
              <div className="col-sm-6">
                <ol className="breadcrumb float-sm-right">
                  <li className="breadcrumb-item">
                    <a href="/admin/dashboard">หน้าหลัก</a>
                  </li>
                  <li className="breadcrumb-item active">วิชาและตัวชี้วัด</li>
                </ol>
              </div>
            </div>
          </div>
        </div>
        
        <section className="content">
          <div className="container-fluid">
            {/* จัดการวิชา */}
            <div className="card card-orange">
              <div className="card-header">
                <h3 className="card-title">รายวิชา</h3>
                <div className="card-tools">
                  <button
                    type="button"
                    className="btn btn-tool"
                    onClick={handleShowAddSubjectModal}
                  >
                    <i className="fas fa-plus"></i> เพิ่มวิชา
                  </button>
                </div>
              </div>
              <div className="card-body">
                {isLoading ? (
                  <div className="loading-spinner">
                    <i className="fas fa-spinner fa-spin"></i>
                  </div>
                ) : (
                  <div className="table-responsive">
                    <table className="table table-bordered table-striped">
                      <thead>
                        <tr>
                          <th style={{ width: '100px' }}>รหัสวิชา</th>
                          <th>ชื่อวิชา</th>
                          <th>คำอธิบาย</th>
                          <th style={{ width: '120px' }}>ตัวเลือก</th>
                        </tr>
                      </thead>
                      <tbody>
                        {subjects.length === 0 ? (
                          <tr>
                            <td colSpan="4" className="text-center">
                              ไม่พบข้อมูลวิชา
                            </td>
                          </tr>
                        ) : (
                          subjects.map((subject) => (
                            <tr key={subject.id}>
                              <td>{subject.subject_code}</td>
                              <td>{subject.subject_name}</td>
                              <td>{subject.description || '-'}</td>
                              <td>
                                <button
                                  className="btn btn-info btn-sm mr-1"
                                  onClick={() => handleShowEditSubjectModal(subject)}
                                >
                                  <i className="fas fa-edit"></i>
                                </button>
                                <button
                                  className="btn btn-danger btn-sm"
                                  onClick={() => handleDeleteSubject(subject.id)}
                                >
                                  <i className="fas fa-trash"></i>
                                </button>
                              </td>
                            </tr>
                          ))
                        )}
                      </tbody>
                    </table>
                  </div>
                )}
              </div>
            </div>
            
            {/* จัดการตัวชี้วัด */}
            <div className="card card-orange">
              <div className="card-header">
                <h3 className="card-title">ตัวชี้วัด</h3>
                <div className="card-tools">
                  <button
                    type="button"
                    className="btn btn-tool"
                    onClick={handleShowAddIndicatorModal}
                    disabled={!selectedSubjectId}
                  >
                    <i className="fas fa-plus"></i> เพิ่มตัวชี้วัด
                  </button>
                </div>
              </div>
              <div className="card-body">
                <div className="row mb-3">
                  <div className="col-md-4">
                    <div className="form-group">
                      <label>กรองตามวิชา</label>
                      <select
                        className="form-control"
                        value={selectedSubjectId}
                        onChange={(e) => setSelectedSubjectId(e.target.value)}
                      >
                        {subjects.map(subject => (
                          <option key={subject.id} value={subject.id}>
                            {subject.subject_code} - {subject.subject_name}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>
                </div>
                
                {isLoading ? (
                  <div className="loading-spinner">
                    <i className="fas fa-spinner fa-spin"></i>
                  </div>
                ) : (
                  <div className="table-responsive">
                    <table className="table table-bordered table-striped">
                      <thead>
                        <tr>
                          <th style={{ width: '120px' }}>รหัสตัวชี้วัด</th>
                          <th>ชื่อตัวชี้วัด</th>
                          <th style={{ width: '100px' }}>คะแนนเต็ม</th>
                          <th style={{ width: '100px' }}>น้ำหนัก</th>
                          <th>คำอธิบาย</th>
                          <th style={{ width: '120px' }}>ตัวเลือก</th>
                        </tr>
                      </thead>
                      <tbody>
                        {filteredIndicators.length === 0 ? (
                          <tr>
                            <td colSpan="6" className="text-center">
                              ไม่พบข้อมูลตัวชี้วัด
                            </td>
                          </tr>
                        ) : (
                          filteredIndicators.map((indicator) => (
                            <tr key={indicator.id}>
                              <td>{indicator.indicator_code}</td>
                              <td>{indicator.indicator_name}</td>
                              <td className="text-center">{indicator.full_score}</td>
                              <td className="text-center">{indicator.weight}</td>
                              <td>{indicator.description || '-'}</td>
                              <td>
                                <button
                                  className="btn btn-info btn-sm mr-1"
                                  onClick={() => handleShowEditIndicatorModal(indicator)}
                                >
                                  <i className="fas fa-edit"></i>
                                </button>
                                <button
                                  className="btn btn-danger btn-sm"
                                  onClick={() => handleDeleteIndicator(indicator.id)}
                                >
                                  <i className="fas fa-trash"></i>
                                </button>
                              </td>
                            </tr>
                          ))
                        )}
                      </tbody>
                    </table>
                  </div>
                )}
              </div>
            </div>
          </div>
        </section>
      </div>
      
      {/* Modal เพิ่ม/แก้ไขข้อมูลวิชา */}
      {showSubjectModal && (
        <div className="modal fade show" style={{ display: 'block', paddingRight: '15px' }}>
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header bg-orange">
                <h5 className="modal-title">
                  {subjectFormMode === 'add' ? 'เพิ่มวิชาใหม่' : 'แก้ไขข้อมูลวิชา'}
                </h5>
                <button type="button" className="close" onClick={handleCloseSubjectModal}>
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <form onSubmit={handleSubjectSubmit}>
                <div className="modal-body">
                  <div className="form-group">
                    <label>รหัสวิชา <span className="text-danger">*</span></label>
                    <input
                      type="text"
                      className="form-control"
                      name="subject_code"
                      value={subjectFormData.subject_code}
                      onChange={handleSubjectInputChange}
                      placeholder="เช่น ท11101, ค11101"
                      required
                    />
                  </div>
                  <div className="form-group">
                    <label>ชื่อวิชา <span className="text-danger">*</span></label>
                    <input
                      type="text"
                      className="form-control"
                      name="subject_name"
                      value={subjectFormData.subject_name}
                      onChange={handleSubjectInputChange}
                      placeholder="เช่น ภาษาไทย 1, คณิตศาสตร์ 1"
                      required
                    />
                  </div>
                  <div className="form-group">
                    <label>คำอธิบาย</label>
                    <textarea
                      className="form-control"
                      name="description"
                      value={subjectFormData.description}
                      onChange={handleSubjectInputChange}
                      placeholder="รายละเอียดวิชา"
                      rows="3"
                    ></textarea>
                  </div>
                </div>
                <div className="modal-footer">
                  <button type="button" className="btn btn-secondary" onClick={handleCloseSubjectModal}>
                    ยกเลิก
                  </button>
                  <button type="submit" className="btn btn-orange" disabled={isLoading}>
                    {isLoading ? (
                      <><i className="fas fa-spinner fa-spin"></i> กำลังบันทึก...</>
                    ) : (
                      <>บันทึก</>
                    )}
                  </button>
                </div>
              </form>
            </div>
          </div>
          
          <div className="modal- fade show"></div>
        </div>
      )}
      
      {/* Modal เพิ่ม/แก้ไขข้อมูลตัวชี้วัด */}
      {showIndicatorModal && (
        <div className="modal fade show" style={{ display: 'block', paddingRight: '15px' }}>
          <div className="modal-dialog modal-lg">
            <div className="modal-content">
              <div className="modal-header bg-orange">
                <h5 className="modal-title">
                  {indicatorFormMode === 'add' ? 'เพิ่มตัวชี้วัดใหม่' : 'แก้ไขข้อมูลตัวชี้วัด'}
                </h5>
                <button type="button" className="close" onClick={handleCloseIndicatorModal}>
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <form onSubmit={handleIndicatorSubmit}>
                <div className="modal-body">
                  <div className="row">
                    <div className="col-md-6">
                      <div className="form-group">
                        <label>วิชา <span className="text-danger">*</span></label>
                        <select
                          className="form-control"
                          name="subject_id"
                          value={indicatorFormData.subject_id}
                          onChange={handleIndicatorInputChange}
                          required
                        >
                          <option value="">-- เลือกวิชา --</option>
                          {subjects.map(subject => (
                            <option key={subject.id} value={subject.id}>
                              {subject.subject_code} - {subject.subject_name}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-group">
                        <label>รหัสตัวชี้วัด <span className="text-danger">*</span></label>
                        <input
                          type="text"
                          className="form-control"
                          name="indicator_code"
                          value={indicatorFormData.indicator_code}
                          onChange={handleIndicatorInputChange}
                          placeholder="เช่น ท1.1.1, ค1.1.1"
                          required
                        />
                      </div>
                    </div>
                  </div>
                  <div className="form-group">
                    <label>ชื่อตัวชี้วัด <span className="text-danger">*</span></label>
                    <input
                      type="text"
                      className="form-control"
                      name="indicator_name"
                      value={indicatorFormData.indicator_name}
                      onChange={handleIndicatorInputChange}
                      placeholder="เช่น อ่านออกเสียงคำ คำคล้องจอง และข้อความสั้นๆ"
                      required
                    />
                  </div>
                  <div className="row">
                    <div className="col-md-6">
                      <div className="form-group">
                        <label>คะแนนเต็ม</label>
                        <input
                          type="number"
                          className="form-control"
                          name="full_score"
                          value={indicatorFormData.full_score}
                          onChange={handleIndicatorInputChange}
                          min="1"
                          step="0.1"
                        />
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-group">
                        <label>น้ำหนัก</label>
                        <input
                          type="number"
                          className="form-control"
                          name="weight"
                          value={indicatorFormData.weight}
                          onChange={handleIndicatorInputChange}
                          min="0.1"
                          step="0.1"
                        />
                      </div>
                    </div>
                  </div>
                  <div className="form-group">
                    <label>คำอธิบาย</label>
                    <textarea
                      className="form-control"
                      name="description"
                      value={indicatorFormData.description}
                      onChange={handleIndicatorInputChange}
                      placeholder="รายละเอียดตัวชี้วัด"
                      rows="3"
                    ></textarea>
                  </div>
                </div>
                <div className="modal-footer">
                  <button type="button" className="btn btn-secondary" onClick={handleCloseIndicatorModal}>
                    ยกเลิก
                  </button>
                  <button type="submit" className="btn btn-orange" disabled={isLoading}>
                    {isLoading ? (
                      <><i className="fas fa-spinner fa-spin"></i> กำลังบันทึก...</>
                    ) : (
                      <>บันทึก</>
                    )}
                  </button>
                </div>
              </form>
            </div>
          </div>
          
          <div className="modal- fade show"></div>
        </div>
      )}
      
      <Footer />
    </div>
  );
}

export default AdminSubjects;